module.exports = __webpack_public_path__ + "static/img/ma01.e8db8b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/ma01.jpg
// module id = R7kf
// module chunks = 0